export default "__VITE_ASSET__BRyerNLC__"